import { BaseWidget } from '@eduact/ed-components'
import React from 'react'
import TimelineElement from './TimelineWidgetElement'

const TimelineWidget = ({ ...args }) => {
	return <BaseWidget onClick={() => {}} widget={TimelineElement} {...args} bg="light" height={'22.95rem'} />
}

export default TimelineWidget
